import * as React from "react";
import {cx} from "emotion";

import "./future-fulfillment.scss";

import {AcceptableFulfillmentDate} from "@Common/logic/future-fulfillment/acceptable-fulfillment-date";
import {getDefaultFulfillmentDate} from "@Common/logic/future-fulfillment/default-fulfillment-date";
import {cs}                        from "@Common/react/chain-services";
import {consumeContext}            from "@Common/react/context";
import {scopedState}               from "@Common/react/scoped-state";
import {DatePicker2}               from "@Common/ui-components/date-picker-2/date-picker-2";
import {DivCollapser2}             from "@Common/ui-components/heavy/common/design2/div-collapser-2/div-collapser-2";
import {SliderCheckbox}            from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {addDate, dateDiff, today}  from "@Common/utils/date-object";
import {parseDateFormat}           from "@Common/utils/date/parse-date-format";

export const FutureFulfillment = ({showErrors, ui: {state, eh, domRef, holidays, valid}}) => cs(
    consumeContext("systemConstants"),
    ["dateFormat", (_, next) => next(parseDateFormat("yyyy-mm-dd"))],
    ({dateFormat, systemConstants}) => (
        <div className="future-fulfillment-3ce">
            <div className="header">
                <div className="left">
                    <div className="title" xd-qa-type="label" xd-qa-name="Schedule Future Fulfillment Date">
                        Schedule Future Fulfillment Date
                    </div>
                    <div className="sub-title">
                        Fulfillment for this item is scheduled for{" "}
                        {parseDateFormat("mm/dd/yy").formatDate(getDefaultFulfillmentDate({holidays}))}.{" "}
                        Select a different date below to schedule for a later date.{" "}
                        Turn this option on to reschedule
                    </div>
                </div>
                <div className="right">
                    {SliderCheckbox({
                        ...scopedState(state, ["selected"]),
                        xdQaName:"Schedule Future Fulfillment Date"
                    })}
                </div>
            </div>

            {!!state.value.selected && (
                <div className="box">
                    <div className="label" xd-qa-type="label" xd-qa-name="Date Picker Description">
                        Choose a date from the calendar to start on a later date
                    </div>

                    <div className="date-picker" ref={domRef}>
                        {DatePicker2({
                            className: eh.css,
                            hasError: showErrors && !valid,
                            state: scopedState(state, ["scheduledDate"]),
                            minDate: addDate(today(), +(systemConstants.value?.MIN_NUM_DAYS_OUT_FOR_SCHEDULING_ORDERS??2)),
                            maxDate: addDate(today(), +(systemConstants.value?.MAX_NUM_DAYS_OUT_FOR_SCHEDULING_ORDERS??90)),
                            dateFormat,
                            isDisabled: (() => {
                                const isAcceptableDate = AcceptableFulfillmentDate({holidays});
                                return (d) => {
                                    if (!isAcceptableDate(d)) {
                                        return true;
                                    }

                                    if (dateDiff(d, today()) > (systemConstants.value?.MAX_NUM_DAYS_OUT_FOR_SCHEDULING_ORDERS??90)) {
                                        return true;
                                    }
                                };
                            })(),
                            xdQaName: "Future Fulfillment Date Picker",
                        })}
                    </div>

                    {cs(
                        ["collapser", (_, next) => DivCollapser2({
                            collapsedHeight: 47,
                            expandedBottomPadding: 25,
                            next,
                        })],
                        ({collapser}) => (
                            <div className={cx("note", {expanded: collapser.expanded})}>
                                {collapser.render({
                                    className: "text",
                                    renderContent: (ref) => (
                                        <div ref={ref}>
                                            <div className="line" xd-qa-type="label" xd-qa-name="Future Fulfillment Description" >
                                                <b>Note:</b> The fulfillment date you select is when production will start. For most items, this means they will ship or mail the next business day from the date you select; unless a longer
                                                production time was stated during the order process. (e.g. 3 - 5 business days)
                                            </div>
                                            <div className="line" xd-qa-type="label" xd-qa-name="Future Fulfillment Description toggle">
                                                Delivery will be determined based on the mailing class or shipping service you selected for this item. Payment is collected at the time the order is placed not when the scheduled order is fulfilled.
                                            </div>
                                        </div>
                                    ),
                                })}

                                {!collapser.pointless && (
                                    <div
                                        className="toggle"
                                        onClick={collapser.toggle}
                                        xd-qa-type="link"
                                        xd-qa-name={"Description Toggle"}
                                    >
                                        {(collapser.collapsed || collapser.collapsing) ? (
                                            "+ More"
                                        ) : (
                                            "- Less"
                                        )}
                                    </div>
                                )}
                            </div>
                        ),
                    )}
                </div>
            )}
        </div>
    ),
);
